<template>
    <v-container class="pa-0 context-status">
        <v-row
          no-gutters
        >
          <v-col
            cols="12"
            style="margin-left: -6px;"
            class="mb-1"
          >
            <ContextItemLabels
              :iconTooltip="$t('shipments.labels')"
              :isEditable="true"
              :featherIcon="'tag-icon'"
              :labels="computedShipmentsLabels"
              :eventName="'click'"
              @handleSaveLabels="handleSaveLabels"
              :algoliaSearchLabels="{ index: 'prod_shipments' }"

            />
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-1" v-if="shipmentStatus.status !== null">
            <v-col cols="1">
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <bookmark-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down']" color="#777777" class="custom-class wrld_black--text"></bookmark-icon>
                    </template>
                    <span>{{$t('shipments.shipment_status')}}</span>
                </v-tooltip>
            </v-col>
            <v-col cols="11" class="status-text wrld_black--text">
                <span>{{$t('shipments.' + shipmentStatus.status) }}</span>
            </v-col>
        </v-row>

        <v-row no-gutters class="mb-1" v-if="shipmentStatus.quote.price !== null">
            <v-col cols="1">
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <dollar-sign-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down']" color="#777777" class="custom-class wrld_black--text"></dollar-sign-icon>
                    </template>
                    <span
                      class="wrld_black--text"
                    >{{$t('shipments.price')}}</span>
                </v-tooltip>
            </v-col>
            <v-col cols="11" class="status-text">
                <span>{{shipmentStatus.quote.price | humanizeNumber}} {{shipmentStatus.quote.currency}}</span>
            </v-col>
        </v-row>

        <v-row no-gutters class="mb-1" v-if="shipmentStatus.quote.status !== null">
            <v-col cols="1">
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <award-icon v-on="on" :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down']" class="custom-class wrld_black--text"></award-icon>
                    </template>
                    <span>{{$t('shipments.quote_status')}}</span>
                </v-tooltip>
            </v-col>
            <v-col cols="11" class="status-text wrld_black--text">
                <span>{{$t('quotes.' + shipmentStatus.quote.status)}}</span>
            </v-col>
        </v-row>

        <v-row no-gutters class="mb-1">
          <v-col cols="12">
            <ContextItemEditablePricing
              :key="shipment.id"
              :customKey="shipment.id"
              :tooltip="$t('shipments.value_of_goods')"
              :pricing="shipment.goodsValue"
              :emptyValue="$t('shipments.add_value_of_goods')"
              @save="handleSaveValueOfGoods"
            />
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import ContextItemLabels from '@/components/wrld/generic/ContextItemLabels'
  import ContextItemEditablePricing from '@/components/wrld/generic/ContextItemEditablePricing'

  export default {
    name: 'ShipmentsGroupByDayContextDrop',
    components: {
      ContextItemLabels,
      ContextItemEditablePricing
    },
    props: {
      shipmentStatus: Object,
      shipment: Object
    },
    methods: {
      ...mapActions({
        setShipmentLabels: 'shipmentsContext/setShipmentLabels',
        handleSetGoodsValueByDay: 'shipmentsContext/handleSetGoodsValueByDay'

      }),
      handleSaveLabels (values) {
        let labels = []
        values.forEach((value) => {
          labels.push(value.name)
        })
        this.setShipmentLabels({ shipment: this.shipment, labels })
      },
      handleSaveValueOfGoods (pricing) {
        this.handleSetGoodsValueByDay({id: this.shipment.id, value: pricing})
      }
    },
    computed: {
      computedShipmentsLabels () {
        let shipmentLabels = []
        if (this.shipmentStatus.labels != null)
        this.shipmentStatus.labels.forEach((label) => {
          shipmentLabels.push({ name: label, color: 'var(--v-wrld_green-base)', textColor: 'var(--v-wrld_black-base)', noTranslate: true })
        })
        return shipmentLabels
      }
    },
  }
</script>

<style lang="scss" scoped>
.context-status {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 13px;
    margin-top: 40px;
}
.label-style {
  padding: 1px 4px;
  border-radius: 20px;
  background-color: var(--v-wrld_green-base);
}
.status-text {
    margin-top: -1px;
}
.icon-xl {
    width: 17px;
    height: 17px;
}
.icon-lg-down {
    width: 15px;
    height: 15px;
}
</style>
